import { Button } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styles from "./Login.module.css";
import logo from "../../../assets/images/logo.png";

import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { LuEye, LuEyeOff } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { showAlert, showLoading } from "../../../Store/Actions/GeneralActions";
import { getUser, isLogin } from "../../../Store/Actions/AuthAction";
import Storage from "../../../utills/AsyncStorage";
import { AuthMiddleware } from "../../../Store/Middlewares/AuthMiddleware";
import { validateEmail } from "../../../utills/Validators";
import HeadingComponent from "../../../components/HeadingComponent/HeadingComponent";

function Login() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const onPressLogin = () => {
    if(!email || !password){
      return dispatch(showAlert({message: "All fields are required", type: "Warning"}));
    }
    if (!validateEmail(email)) {
      return dispatch(showAlert({message: "Please enter a valid email address", type: "Warning"}));
    }
    
    let data = {
      email: email,
      password: password,
    };

    dispatch(AuthMiddleware.login(data))
    .then(() => {})
    .catch((err) => { console.log("error", err) });
  };

  return (
    <div className={styles.mainCont}>
      <div className={styles.leftCont}>
        <img src={logo} className={styles.logoImg} />
      </div>
      <div className={styles.rightCont}>
        <div className={styles.rightWidthCont}>
          <div className={styles.textDiv}>
            <HeadingComponent
              text={"Admin Panel"}
              color={"var(--primary-color)"}
              padding={"0px"}
            />

            <TextComponent
              className={styles.welcomeText}
              color={"var(--light-text)"}
              text={"Login to proceed"}
            />
          </div>
          <div className={styles.inputDiv}>
            <InputField
              className={styles.input}
              label={"Email Address"}
              placeholder={"chris@email.com"}
              // LabelColor={"var(--white-color)"}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <InputField
              className={styles.input}
              LabelColor={"var(--white-color)"}
              label={"Password"}
              placeholder={"●●●●●●●●●●"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              rightIcon={
                passwordVisible ? (
                  <LuEye size={20} color={"var(--input-icon)"} />
                ) : (
                  <LuEyeOff size={20} color={"var(--input-icon)"} />
                )
              }
              onRightIconPress={() => setPasswordVisible(!passwordVisible)}
              type={passwordVisible ? "text" : "password"}
            />
       
          </div>
          <div className={styles.btn}>
            <SubmitButton
              title={"Login"}
              onClick={onPressLogin}
              primary
              btnContainerClass={styles.Login_btnContainer}
              textClass={styles.Login_Text}
              btnClass={`${styles.Login_btn}`}
            />
          </div>
       
        </div>
      </div>
    </div>
  );
}

export default Login;
